import { render, staticRenderFns } from "./menu-joinus.vue?vue&type=template&id=9fa20c2a&scoped=true&lang=pug"
import script from "./menu-joinus.vue?vue&type=script&lang=ts"
export * from "./menu-joinus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa20c2a",
  null
  
)

export default component.exports